import { MenuItem, Typography } from "@mui/material"
import config from '../../../services/config.json'

export const VersionMenuItem = () => {
    return (
        <MenuItem
            sx={{
            display: "flex",
            justifyContent: "center"
            }}
        >
            <Typography
                fontSize="12px"
                sx={{ opacity: 0.5 }}
                textAlign="center"
            >
                Versão { config.version }
            </Typography>
        </MenuItem>
    )
}